import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getResolutionName } from "../../../WorkkardDetail/utils";
import { completeDiary,fetchDiaryInfo,resetViewDiaryInfo } from "../../../../containers/Diaries/actions";
import Detail from "./detail";
import { showDialogueBox, hideDialogueBox } from '../../../../components/DialogueBox/actions';
import { hideTooltip } from '../../../SpockViewPage/actions/action';
import DiaryDetailPopUp from '.././../../../components/DiaryDetailPopUp';

const DiaryInfo = (props) => {
  const dispatch = useDispatch();

  const { diaryInfo,timezoneTz } = useSelector(
    (state) => ({
      diaryInfo: state.diaries.view.diaryInfo,
      timezoneTz: state.sessionContext.TimeZoneTz
    }),
    shallowEqual
  );

  const [checked, setChecked] = useState(false);
  const [status, setStatus] = useState("");

  const data = props.data || diaryInfo.detail;

  useEffect(() => {
    if (data.IsCompleted) {
      setChecked(true);
    }
    setStatus(data.Status);
  }, []);

  return (
    <div>
      {Object.keys(data).length > 0 && (
        <div className={`diaresStatus ccCalendar toolTipDiary`}>
          <div>
              <div className="filterBlock rowFlex">
                <div className="filterLeft">
                  {
                    (data.Status != "CANCELLED") &&
                    <div className="radioButton" data-test="radioButton" key={data.TodoId} onClick={() => {
                      dispatch(
                        completeDiary({
                          id: data.TodoId,
                          isComplete: checked ? false : true,
                          key: props.dataKey,
                          completedDate: moment.utc().format('l [at] h:mm A')
                        })
                      );
                      setStatus(checked ? "OPEN":"COMPLETED");
                      setChecked(!checked);
                    }}>
                      <span className={checked ? "completeCheck mr checked": "completeCheck mr"}></span>
                    </div>
                  }
                  <a className="pointer checkTitle" data-test="diaryTitle" onClick={() => {
                    dispatch(hideTooltip());
                    dispatch(
                      fetchDiaryInfo({
                        target: null,
                        id: data.TodoId,
                        key: props.dataKey,
                        isErrorScreen:false
                      })
                    );
                    dispatch(
                      showDialogueBox({
                        flag: true,
                        component: (
                          <DiaryDetailPopUp
                            dataKey={props.dataKey}
                            onClose={() => {
                              dispatch(hideDialogueBox());
                              dispatch(resetViewDiaryInfo());
                            }}
                          />
                        ),
                        overlayClassName: "modal",
                        contentClassName: "modalContent animated faster fadeInUpx2 medium",
                        shouldCloseOnOverlayClick: false,
                      })
                    );
                  }}>
                    {data.Title}
                  </a>
                </div>
                <div className="filterRight" data-test="diaryStatus">
                  <span className={`mr status ${status && getResolutionName(status.toLowerCase(), true)} workkardStatus`}>
                    {status && getResolutionName(status.toLowerCase())}
                  </span>
                </div>
              </div>
          </div>
          <div className={`detailsData`}>
            <Detail data={data} userTimeZone = {timezoneTz} status={status}/>
          </div>
        </div>
      )}
    </div>
  );
};

export default DiaryInfo;
